import { resolveAllAvailability, resolveAvailability } from './resolvers/availability.resolver';
import { resolveStock, resolveSingleStock } from './resolvers/stock.resolver';
import { resolveGroupedEvents } from '../event/resolvers/events.resolver';
import { resolveCategories, resolveCategoriesEvents } from '../event/resolvers/categories.resolver';

export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.availability', {
            url: '/availability',
            component: 'availabilityList',
            resolve: {
                exclusion: resolveAllAvailability(undefined, undefined, undefined, 'exclusion'),
                inclusion: resolveAllAvailability(undefined, undefined, undefined, 'inclusion')
            },
            roles: []
        })
        .state('app.admin.availability-add', {
            url: '/availability/create?:tab',
            component: 'availabilitySave',
            resolve: {
                title: () => 'Create an Availability Rule',
                availability: resolveAvailability(),
                categories: resolveCategories(-1),
                events: resolveGroupedEvents()
            },
            roles: []
        })
        .state('app.admin.availability-block', {
            url: '/availability/quick-block',
            component: 'availabilityBlock',
            resolve: {
                title: () => 'Block a Day',
            },
            roles: []
        })
        .state('app.admin.availability-edit', {
            url: '/availability/:availability/:type/update',
            component: 'availabilitySave',
            resolve: {
                title: () => 'Update an Availability Rule',
                availability: resolveAvailability(),
                categories: resolveCategories(-1),
                events: resolveGroupedEvents()
            },
            roles: []
        })
        .state('app.admin.stock', {
            url: '/stock',
            component: 'stockList',
            resolve: {
                stock: resolveStock()
            },
            roles: ['manager', 'stock']
        })
        .state('app.admin.stock-add', {
            url: '/stock/create',
            component: 'stockForm',
            resolve: {
                availability: resolveAvailability(),
                categories: resolveCategoriesEvents(-1),
                events: resolveGroupedEvents(),
            },
            roles: ['manager', 'stock']
        })
        .state('app.admin.stock-update', {
            url: '/stock/update/:stock',
            component: 'stockForm',
            resolve: {
                stock: resolveSingleStock(),
                events: resolveGroupedEvents(),
            },
            roles: ['manager', 'stock']
        })
        ;
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/availability.routes.js